<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <vue-final-modal v-model="informationModal" classes="base-modal" :ssr="true"
        content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000" :lock-scroll="true"
        :hide-overlay="false" :click-to-close="true" :esc-to-close="true" :prevent-click="true" :attach="false"
        transition="vfm" overlay-transition="vfm" :z-index-auto="true" :z-index-base="1000" :z-index="false"
        :focus-retain="true" :focus-trap="false" :fit-parent="true" :drag="false" drag-selector=""
        :keep-changed-style="false" :resize="false" :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
        :min-width="250" :min-height="250" :max-width="Infinity" :max-height="Infinity">
        <!-- Modal header -->
        <div class="modal-head">
            <h1>Information</h1>

            <jb-button class="btn-close-modal" :icon="mdiClose" @click="store('no')" />
        </div>

        <!-- Modal Content -->
        <div class="modal-content detail-content">
            <div class="w-full px-4 py-6">
                <p>This Employee has been assigned for {{ position.position_name }} - {{ position.department_name }} as his / her Main Job. Do you want to change into this record as his / her Main Job?</p>
            </div>

            <jb-buttons class="flex justify-center w-full" style="padding: 15px !important;">
                <jb-button label="Yes" color="info" @click="store('yes')" class="w-1/2  " />
                <jb-button label="No" color="danger" outline @click="store('no')" class="w-2/5  " />
            </jb-buttons>
        </div>
    </vue-final-modal>

    <form @submit.prevent="store('')" class="form-content">
        <div class="form-content-inner">

            <div class="form-col">
                <control type="hidden" v-model="position.id" id="id" />
            </div>

            <div class="form-col">
                <field :label="$t('position.title')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control :options="HRPositionList" v-model="position.position_id" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('vaccines.department')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control :options="departmentList" v-model="position.department_id" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('position.date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <datepicker v-model="position.tmt" :enableTimePicker="false" name="tmt" :auto-apply="true"/>
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('position.decree')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control type="text" v-model="position.sk" />
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('vaccines.description')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control type="text" v-model="position.description" />
                </field>
            </div>

            <div class="form-col">
                <field label="File" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <input type="file" accept="application/pdf" v-on:change="onFileChange" class="form-control-file" id="my-file">
                </field>
            </div>

            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { axiosDocument } from "@/boot/axios";
import { mdiBallot, mdiCheckBold, mdiClose } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import { getHRPositionData, getDepartmentData } from '@/composables/global'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        },
        propPosition: {
            type: Array,
            default: () => []
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'is-new', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)

        const toast = useToast()

        const router = useRouter()

        const errors = ref([])
        const { HRPositionList } = getHRPositionData()
        const { departmentList } = getDepartmentData()
        const options = ['ID Card', 'Family Card', 'Passport', 'TIN']
        const preview = ref('')

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const position = reactive({
            id: '',
            position_id: '',
            tmt: '',
            sk: '',
            is_main: true,
            description: '',
            department_id: '',
            position_name: '',
            department_name: '',
            file: '',
            created_by: '',
            updated_by: ''
        })

        const customElementsForm = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            is_active: [1],
            file: null
        })

        const onFileChange = async (event, evt) => {
            const file = event.target.files[0]
            if (file) {
                if (file.type !== 'application/pdf') {
                    alert('Only PDF files are allowed');
                    event.target.value = ''
                }
                else if (file.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    file.value = ''
                } else {
                    const reader = new FileReader()
                    reader.onloadend = function () {
                        preview.value = reader.result
                }
                reader.readAsDataURL(file)
                }
            } else {
                preview.value = ''
            }
        }

        const informationModal = ref(false)
        const store = async (env) => {
            if(!props.showEdit && env == '' && (props.propPosition && props.propPosition.length > 0)){
                informationModal.value = true

                const HRPositionListFirst = HRPositionList.value.filter(function (item) { return item.id === position.position_id })
                if(HRPositionListFirst && HRPositionListFirst.length > 0){
                    position.position_name = HRPositionListFirst[0].name
                }
                const departmentListFirst = departmentList.value.filter(function (item) { return item.id === position.department_id })
                if(departmentListFirst && departmentListFirst.length > 0){
                    position.department_name = departmentListFirst[0].name
                }
                
                return true
            }
            
            position.is_main = env == 'yes' || env == '' ? true : false

            isLoading.value = true
            const url = props.showEdit ? 'employeeposition/' + position.id : 'employeeposition';
            const method = props.showEdit ? "PUT" : "POST";

            position.created_by = userlogin
            position.file = preview.value
            console.log('position', position)

            const jsonData = JSON.stringify(position)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };

            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    informationModal.value = false
                    if (response.data.success) {
                        if(response.data.is_doc > 0 && position.file != ''){
                            storeDoc(response.data.link_doc)
                        } else {
                            isLoading.value = false
                            emit('close-modal')
                            if(!props.showEdit){
                                emit('is-new')
                            }

                            emit('refresh-list')
                            toast.success(response.data.message)
                        }
                    } else {
                        isLoading.value = false
                        toast.error(response.data.message)
                    }
                })
                .catch(error => {
                    informationModal.value = false
                    isLoading.value = false
                    console.log(error)
                })
        }
        // if doc academic active = true
        const storeDoc = (env) => {
            const url = 'doc-file-employee'
            const method = 'POST'

            isLoading.value = true
            const paramsData = {
                link_doc: env
            }
            const jsonData = JSON.stringify(paramsData)
            console.log('paramsData DOC', paramsData)

            const configHeaders = {
                'content-type': 'application/json',
                Accept: 'application/json'
            }

            axiosDocument({
                method,
                url,
                data: jsonData,
                headers: configHeaders
            })
            .then(response => {
                isLoading.value = false
                emit('close-modal')
                if(!props.showEdit){
                    emit('is-new')
                }

                emit('refresh-list')
                toast.success(response.data.message)
            })
            .catch(error => {
                isLoading.value = false
                console.log('error', error)
            })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // position.value =toRefs(props, 'propClass')
        })

        watch(() => props.propClass, (newVal, oldVal) => {
            position.file = ''
            position.description = ''
        })

        watchEffect(() => {
            console.log('props.propPosition', props.propPosition)
            const newobject = props.propObject;
            Object.assign(position, newobject);

            if (!props.showEdit) {
                position.id = null;
                position.position_id = null;
                position.tmt = null;
                position.sk = null;
                position.is_main = true;
                position.description = null;
                position.department_id = null;
                position.position_name = null;
                position.department_name = null;
                position.file = null;
            }

            const newposition = props.propClass
            position.submenu = newposition.submenu
            position.ein = newposition.ein
            position.employee_id = newposition.employee_id
            position.nickname = newposition.nickname
        })
        
        return {
            informationModal,
            titleStack,
            onFileChange,
            customElementsForm,
            mdiBallot,
            mdiCheckBold,
            mdiClose,
            options,
            router,
            position,
            store,
            HRPositionList,
            departmentList,
            toast,
            userlogin,
            errors,
            isLoading
        }
    },
    methods: {
        // async store () {
        //     const dataForm = {
        //         id: this.position.id,
        //         name: this.position.name,
        //         academic_year_id: this.position.academic_year_id,
        //         capacity: this.position.capacity,
        //         homeroom_id: this.position.homeroom_id ?? this.position.level_id,
        //         is_active: this.customElementsForm.is_active ?? false,
        //         remarks: this.position.remarks,
        //         level_id: this.position.level_id,
        //         department_id: this.position.department_id,
        //         remarks1: this.position.remarks1,
        //         remarks2: this.position.remarks2,
        //         remarks3: this.position.remarks3,
        //         created_by: 'admin',
        //         updated_by: this.position.updated_by
        //     }
        //     // await axios
        //     //     .post('class', dataForm)
        //     //     .then(response => {
        //     //         if (response.data.success) {
        //     //         } else {
        //     //             this.errors = response.data.messages
        //     //         }
        //     //     })
        //     //     .catch(error => {
        //     //         if (error.response) {
        //     //             console.log(error)
        //     //             console.log(JSON.stringify(error.request))
        //     //         } else if (error.message) {
        //     //             console.log(error.message)
        //     //             console.log(JSON.stringify(error.message))
        //     //         }
        //     //     })
        // },
        clearForm () {
            this.position = reactive({
                id: '',
                description: '',
                created_by: ''
            })
        },
        onChange: function (department_id, event) {
            if (event.target.value) {
                department_id = event.target.value
            }
            this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
            this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
        }
    },
    created () {
        this.levelListFilter = this.levelList
        this.academicYearListFilter = this.academicYearList
    }
}
</script>
